import { event as e } from 'shared/experiments/utils/event'

export const PASSWORD_ENFORCEMENT_CHANGE_SUBMIT = e`PASSWORD_ENFORCEMENT_CHANGE_SUBMIT`
export const PASSWORD_ENFORCEMENT_REGISTER_SUBMIT = e`PASSWORD_ENFORCEMENT_REGISTER_SUBMIT`
export const PASSWORD_ENFORCEMENT_RESET_SUBMIT = e`PASSWORD_ENFORCEMENT_RESET_SUBMIT`
